import React from 'react';
import { ChevronRight } from 'lucide-react';
import COLORS from "../Helpers/utils";
import "./BreadCrumb.css"
import {useNavigate} from "react-router-dom";

export interface BreadcrumbItem {
    text: string;
    link?: string;
}

interface BreadcrumbProps {
    items?: BreadcrumbItem[];
}

export const BreadcrumbComponent: React.FC<BreadcrumbProps> = ({ items = [] }) => {
    const navigate = useNavigate();

    const handleNavigation = (link: string) => {
        navigate(link);
    };

    const allItems = [{
        text: 'Byggnader',
        link: '/map'
    }, ...items];

    return (
        <nav style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            width: "fit-content",
            marginLeft: '20px',
            marginTop: '20px',
            backgroundColor: COLORS.breadcrumbBackground,
            borderRadius: '7px',
            color: 'white',
            padding: '5px 15px',
            fontSize: '10pt',
            gap: '8px'
        }}>
            {allItems.map((item, index) => (
                <React.Fragment key={index}>
                    {
                        item.link ?
                            <span onClick={() => { handleNavigation(item.link!)} }
                                  className="breadcrumb-item" style={{cursor: 'pointer'}}>
                                {item.text}
                            </span>
                            :
                            <span style={{fontWeight: '650', cursor: 'default'}}> {item.text} </span>
                    }
                    {index < allItems.length - 1 && (
                        <ChevronRight size={16} />
                    )}
                </React.Fragment>
            ))}
        </nav>
    );
};